import {PageForm} from '/src/layouts/page';
import IntegrationForm from "../../../features/plugins/integrations/components/IntegrationForm/IntegrationForm.js";
import QuotePart from '/src/components/quote/QuotePart';
function IntegrationList() {

    return (
        <PageForm>
                <IntegrationForm/>
                <QuotePart/>
        </PageForm>

    );
}

export default IntegrationList;